
/**
 * 筛选历史记录组件
 * 显示用户的历史筛选记录，支持再次使用和展开收起功能
 */
import { mapGetters } from 'vuex'
import Empty from './empty.vue'
import { getDefaultFilterValue } from './useFast'
import { getPriceNameList } from './usePrice'
import { FieldType } from './enum'

export default {
	name: 'History',
	components: {
		Empty
	},
	props: {
		gameId: {
			type: Number,
			required: true
		},
		filterOptions: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			// 显示的筛选项数量（收起状态下）
			collapsedItemsCount: 4,
			expandIndexList: []
		}
	},
	computed: {
        ...mapGetters({
            getFastFilter: 'filter/getFastFilter',
        }),
        history() {
            return this.getFastFilter(this.gameId)
        },
		// 获取当前游戏的历史筛选数据
		historyData() {
            const { history } = this
			if (history) {
				return history.map(item => {
					const l = []
					if (item?.server?.length) {
						l.push({
							name: '区服',
							id: 'server',
							value: item.server.map((x) => x.name).join(this.desperate('>'))
						})
					}
					if (item.sort?.sort) {
						l.push({
							name: '排序',
							id: item.sort.sortName + item.sort.order,
							value: item.sort.sortName + (item.sort.order === 'ASC' ? '从低到高' : '从高到低')
						})
					}
					if (item?.quickField?.length || item?.filterSearchPropertyIds?.length) {
						l.push({
							name: '标签',
							id: 'quickField',
							value: (item?.quickField || []).concat(item?.filterSearchPropertyIds || []).map(x => x.propertyName).join(this.desperate('｜'))
						})
					}

					return l.concat(item.list)
				})
			}
			return []
		},
	},
	methods: {
		desperate(c = '|') {
			return `<span style="color: #ccc">${c}</span>`
		},
		/**
		 * 切换历史记录项的展开/收起状态
		 * @param index 历史记录项索引
		 */
		toggleExpanded(index) {
			if (this.expandIndexList.includes(index)) {
				this.expandIndexList = this.expandIndexList.filter(i => i !== index)
			} else {
				this.expandIndexList.push(index)
			}
		},
		/**
		 * 获取筛选项的显示值
		 * @param item 筛选项数据
		 * @returns 格式化后的显示文本
		 */
		getFilterValue(item) {
			if (item.fieldType === 'SECTION') {
				// 区间类型：显示最小值-最大值
				let t = `${item.value.min || 0}-${item.value.max || ''}`
				if (item.mappingField === 'price') {
					t = `¥ ${getPriceNameList(item.value, '')}`
				}
				return t
			} else if ([FieldType.SINGLE, FieldType.LABEL, FieldType.CHECKBOX].includes(item.fieldType)) {
				// 单选/多选类型：用｜分隔名称列表
				const values = item.value
				return values?.map(v => v?.nickName || v?.name).join(this.desperate('｜')) || ''
			} else if (item.fieldType === FieldType.SINGLE_CASCADE) {
				// 级联选择类型：用>分隔层级
				const values = item.value
				return values?.map(v => v?.nickName || v?.name).join(this.desperate('>')) || ''
			} else {
				return item.value
			}
		},
		/**
		 * 处理再次筛选操作
		 * @param index 历史记录的索引
		 */
		handleRefilter(index) {
			// 先将该记录置顶
			// 发送搜索事件，第二个参数表示这是再次筛选，不需要添加新记录
            const filter = this.history[index]
			this.$emit('reSearch', this.filterOptions.map(item => {
				const historyItem = this.historyData[index].find((x) => x.id === item.id)
				return {
					...item,
					...getDefaultFilterValue(item),
					...historyItem
				}
			}), filter)
            this.$emit('closePopup')
		}
	}
}
